import React, { useState, useEffect } from 'react';
import './EquipmentModal.css';

const ISOLEMENT_OPTIONS = ["1", "10", "M", "B", "<0,5", ">0,5", "100"];

export default function EclairageSecuriteModal({ isOpen, onClose, onSave, local, equipment }) {
  const [formData, setFormData] = useState({
    category: 'eclairage_securite',
    name: '',
    existing_quantity: 1,
    verified_quantity: 1,
    protection_type: '',
    continuity_result: 'Classe II',
    isolement: '',
    result: 'conforme'
  });

  useEffect(() => {
    if (equipment) {
      setFormData(equipment);
    }
  }, [equipment]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.continuity_result) {
      alert('Veuillez remplir tous les champs obligatoires');
      return;
    }
    onSave({
      type: 'eclairage_securite',
      ...formData
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="equipment-modal-overlay" onClick={onClose}>
      <div className="equipment-modal" onClick={(e) => e.stopPropagation()}>
        <div className="equipment-modal-header">
          <div>
            <h2 className="equipment-modal-title">🚨 Éclairage de Sécurité</h2>
            <p className="equipment-modal-subtitle">{local?.nom}</p>
          </div>
          <button onClick={onClose} className="equipment-close-button">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="equipment-form">
          <div className="equipment-form-scroll">
            <p className="equipment-info-text" style={{ marginBottom: '16px' }}>
              Ce formulaire permet d'ajouter des équipements d'éclairage de sécurité comme les BAES, blocs de secours, éclairages d'évacuation, etc.
            </p>

            <div className="equipment-form-group">
              <label className="equipment-form-label">
                Type d'éclairage de sécurité <span className="equipment-required">*</span>
              </label>
              <select
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                className="equipment-form-select"
                required
              >
                <option value="">- Sélectionner -</option>
                <option value="Luminaire BAES (Bloc Autonome d'Éclairage de Sécurité)">BAES (Bloc Autonome d'Éclairage de Sécurité)</option>
                <option value="Luminaire BAEH (Bloc Autonome d'Éclairage d'Habitation)">BAEH (Bloc Autonome d'Éclairage d'Habitation)</option>
                <option value="Luminaire LSC (Luminaire sur Source Centrale)">LSC (Luminaire sur Source Centrale)</option>
                <option value="Luminaire Bloc d'évacuation">Bloc d'évacuation</option>
                <option value="Luminaire Bloc d'ambiance">Bloc d'ambiance</option>
                <option value="Luminaire Bloc bi-fonction">Bloc bi-fonction</option>
                <option value="Luminaire BAAS (Bloc Autonome d'Alarme Sonore)">BAAS (Bloc Autonome d'Alarme Sonore)</option>
                <option value="Luminaire UGA (Unité de Gestion d'Alarme)">UGA (Unité de Gestion d'Alarme)</option>
                <option value="Luminaire Autre dispositif de sécurité d'éclairage">Autre dispositif de sécurité d'éclairage</option>
              </select>
            </div>

            <div className="equipment-form-row">
              <div className="equipment-form-group">
                <label className="equipment-form-label">Quantité existante</label>
                <input
                  type="number"
                  min="0"
                  value={formData.existing_quantity}
                  onChange={(e) => setFormData({...formData, existing_quantity: parseInt(e.target.value)})}
                  className="equipment-form-input"
                />
              </div>
              <div className="equipment-form-group">
                <label className="equipment-form-label">
                  Quantité vérifiée <span className="equipment-required">*</span>
                </label>
                <input
                  type="number"
                  min="0"
                  value={formData.verified_quantity}
                  onChange={(e) => setFormData({...formData, verified_quantity: parseInt(e.target.value)})}
                  className="equipment-form-input"
                  required
                />
              </div>
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">Type de protection</label>
              <input
                type="text"
                value={formData.protection_type}
                onChange={(e) => setFormData({...formData, protection_type: e.target.value})}
                className="equipment-form-input"
                placeholder="Ex: IP20, IP44, etc."
              />
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">
                Continuité PE <span className="equipment-required">*</span>
              </label>
              <select
                value={formData.continuity_result}
                onChange={(e) => setFormData(prev => ({
                  ...prev,
                  continuity_result: e.target.value,
                  isolement: e.target.value === 'Mauvais' ? '>0,5' : prev.isolement
                }))}
                className="equipment-form-select"
                required
              >
                <option value="">- Sélectionner -</option>
                <option value="Bon">Bon</option>
                <option value="Mauvais">Mauvais</option>
                <option value="Classe II">Classe II</option>
                <option value="NVE">NVE</option>
                <option value="NVI">NVI</option>
                <option value="NVX">NVX</option>
                <option value="SO-PI">SO-PI</option>
              </select>
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">Isolement (MΩ)</label>
              <input
                type="text"
                list="isolement-options-eclairage-securite"
                value={formData.isolement || ''}
                onChange={(e) => setFormData({...formData, isolement: e.target.value})}
                className="equipment-form-input"
                placeholder="Ex: >0,5, 1, 10, 100, M, B..."
              />
              <datalist id="isolement-options-eclairage-securite">
                {ISOLEMENT_OPTIONS.map(opt => <option key={opt} value={opt} />)}
              </datalist>
            </div>
          </div>

          <div className="equipment-form-buttons">
            <button type="button" onClick={onClose} className="equipment-cancel-button">
              ← Retour
            </button>
            <button type="submit" className="equipment-save-button">
              {equipment ? 'Mettre à jour' : '+ Ajouter rapidement'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}